import React, { useEffect, useState } from 'react'
import { Col, Row, Table } from 'antd'
import { AxiosResponse } from 'axios'
import { groupBy } from 'lodash'
import Icon from '@ant-design/icons'

import { faPuzzlePiece } from '@fortawesome/free-solid-svg-icons'
import ViewPage from '../../../../Components/ViewPage'
import { pagination } from '../../../../Components/Default'
import FormCompatibilidadeInsumos from '../../../../Components/recomendacao/compatibilidadeInsumos'
import {
  CompatibilidadeInsumos as InsumosCompatibilidade,
  getCompatibilidadeInsumos,
  TypeCompatibilidadeInsumos,
} from '../../../../services/recomendacao/compatibilidadeProduto'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'
import Icons from '../../../../Components/Icons'

const CompatibilidadeInsumos: React.FC = () => {
  const [visibleForm, setVisibleForm] = useState(false)

  const [rowKeyExpanded, setRowKeyExpanded] = useState([])

  const [tableLoading, setTableLoading] = useState(false)

  const [permissions, setPermissions] = useState<ItensPerUserLogged>()

  const [dataTable, setDataTable] = useState<InsumosCompatibilidade[]>([])

  const handleClickNew = () => {
    setVisibleForm(true)
  }
  const listCompatibilidadeInsumos = async () => {
    setTableLoading(true)
    const resp: AxiosResponse<TypeCompatibilidadeInsumos> = await getCompatibilidadeInsumos({
      pagination: -1,
    })
    const dados = groupBy(resp.data.itens, 'produto_nome')
    let temp = []
    Object.entries(dados).forEach(([key, value]) => {
      temp = [...temp, { nomeInsumo: key, data: value }]
    })
    setDataTable(temp)
    setTableLoading(false)
  }
  const handleChangeRowExpanded = (expanded, record) => {
    const keys = []
    if (expanded) {
      keys.push(record.nomeInsumo)
    }
    setRowKeyExpanded(keys)
  }
  useEffect(() => {
    listCompatibilidadeInsumos()
  }, [])
  return (
    <ViewPage
      rotina={39}
      nameButton='Editar ou Criar'
      onPermission={setPermissions}
      title='Compatibilidades/Incompatibilidades de insumos'
      btnClick={handleClickNew}
      search
      content={
        <FormCompatibilidadeInsumos
          permissions={permissions}
          visible={visibleForm}
          onClose={setVisibleForm}
          onResponse={listCompatibilidadeInsumos}
        />
      }
    >
      <Table
        rowKey='nomeInsumo'
        loading={tableLoading}
        size='small'
        scroll={{ y: 'calc(90vh - 275px)' }}
        pagination={pagination}
        dataSource={dataTable}
        footer={() => (
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'right',
            }}
          >
            <b>Total geral: {dataTable.length}</b>
          </div>
        )}
        expandable={{
          expandedRowKeys: rowKeyExpanded,
          onExpand: handleChangeRowExpanded,
          expandedRowRender: (record) => {
            let compativel = []
            record.data.forEach((re) => {
              Object.entries(re).forEach(([key, value]) => {
                if (
                  (key === 'cod_insumo' && value !== null) ||
                  (key === 'cod_ingrediente_ativo' && value !== null) ||
                  (key === 'cod_grupo_quimico' && value !== null) ||
                  (key === 'cod_cultura' && value !== null) ||
                  (key === 'cod_tecnologia' && value !== null)
                ) {
                  compativel = [...compativel, { tipo: key, value }]
                  return compativel
                }

                compativel = compativel.map((data) => {
                  if (data.tipo === 'cod_insumo' && data.value === re.cod_insumo) {
                    data.name = re.insumo_nome
                    data.nomeTipo = 'Insumo'
                    data.cod = re.cod_insumo
                    data.status = re.cod_tipo
                  }
                  if (
                    data.tipo === 'cod_ingrediente_ativo' &&
                    data.value === re.cod_ingrediente_ativo
                  ) {
                    data.name = re.ingrediente_ativo_nome
                    data.nomeTipo = 'Ingrediente ativo'
                    data.cod = re.cod_ingrediente_ativo
                    data.status = re.cod_tipo
                  }
                  if (data.tipo === 'cod_grupo_quimico' && data.value === re.cod_grupo_quimico) {
                    data.name = re.grupo_quimico_nome
                    data.cod = re.cod_grupo_quimico
                    data.nomeTipo = 'Grupo químico'
                    data.status = re.cod_tipo
                  }
                  if (data.tipo === 'cod_cultura' && data.value === re.cod_cultura) {
                    data.name = re.cultura_nome
                    data.cod = re.cod_cultura
                    data.nomeTipo = 'Cultura'
                    data.status = re.cod_tipo
                  }
                  if (data.tipo === 'cod_tecnologia' && data.value === re.cod_tecnologia) {
                    data.name = re.tecnologia_nome
                    data.cod = re.cod_tecnologia
                    data.nomeTipo = 'Tecnologia'
                    data.status = re.cod_tipo
                  }
                  return data
                })
              })
            })

            const dados = {
              compativel: compativel.filter((data) => data.status === 1),
              incompativel: compativel.filter((data) => data.status === 2),
            }

            return (
              <Col span={23}>
                <Row>
                  <Col span={12}>
                    <Table
                      size='small'
                      dataSource={dados.compativel}
                      bordered
                      pagination={pagination}
                      footer={() => (
                        <div
                          style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'right',
                          }}
                        >
                          <b>Total geral: {dados.compativel.length}</b>
                        </div>
                      )}
                      locale={{
                        emptyText: (
                          <>
                            <Icon component={() => <Icons icon={faPuzzlePiece} />} />
                            <> Não possui compatibilidade</>
                          </>
                        ),
                      }}
                    >
                      <Table.ColumnGroup title='Compatibilidades'>
                        <Table.Column dataIndex='nomeTipo' title='Tipo' />
                        <Table.Column dataIndex='name' title='Nome' />
                      </Table.ColumnGroup>
                    </Table>
                  </Col>
                  <Col span={12}>
                    <Table
                      size='small'
                      dataSource={dados.incompativel}
                      bordered
                      pagination={pagination}
                      footer={() => (
                        <div
                          style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'right',
                          }}
                        >
                          <b>Total geral: {dados.incompativel.length}</b>
                        </div>
                      )}
                      locale={{
                        emptyText: (
                          <>
                            <Icon component={() => <Icons icon={faPuzzlePiece} />} />
                            <> Não possui incompatibilidade</>
                          </>
                        ),
                      }}
                    >
                      <Table.ColumnGroup title='Incompatibilidades '>
                        <Table.Column
                          dataIndex='nomeTipo'
                          title='Tipo'
                          render={(data) => <div style={{ color: 'red' }}>{data}</div>}
                        />
                        <Table.Column
                          dataIndex='name'
                          title='Nome'
                          render={(data) => <div style={{ color: 'red' }}>{data}</div>}
                        />
                      </Table.ColumnGroup>
                    </Table>
                  </Col>
                </Row>
              </Col>
            )
          },
        }}
        columns={[
          {
            key: 1,
            title: 'Nome do insumo',
            dataIndex: 'nomeInsumo',
          },
        ]}
      />
    </ViewPage>
  )
}

export default CompatibilidadeInsumos
